import { scale } from "chroma-js";
import React from "react";
import { Radar } from "react-chartjs-2";

import { Card, Row, Col } from "reactstrap";

const RadarChart = ({ labels, datasets, item }) => {
  const data = {
    labels: labels,
    datasets: [
      {
        label: "結果値",
        backgroundColor: "rgba(175, 249, 169, 0.35)",
        borderColor: "rgba(3, 118, 28, 0.33)",
        // pointBackgroundColor: "rgba(255,99,132,1)",
        // pointBorderColor: "#fff",
        // pointHoverBackgroundColor: "#fff",
        // pointHoverBorderColor: "rgba(255,99,132,1)",
        data: datasets,
      },
    ],
  };

  const options = {
    scale: {
      ticks: {
        beginAtZero: true,
      },
    },
  };

  const options_for_evaluation = {
    scale: {
      ticks: {
        beginAtZero: true,
        stepSize: 1,
        max: 5,
        min: 0,
      },
    },
  };

  return (
    <Card style={{ paddingTop: 100, paddingBottom: 100 }}>
      <div className="scale">
        <Radar
          data={data}
          options={item === "組織診断" ? options_for_evaluation : options}
        />
      </div>
    </Card>
  );
};

export default RadarChart;
